import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { creatorLightTheme } from '@spotify-internal/encore-web/core';
import { useActiveSubmenuContext } from '../../ActiveSubmenu/ActiveSubmenuProvider';
import { useSubmenuItem } from '../../ActiveSubmenu/useSubmenuItem';
import { isFlyoutSubMenu } from '../FlyoutMenu/SubMenu';
import { flyoutTransitionMixin } from '../FlyoutMenu/config';
import { useScrollYPosition } from '../../../utils/useScrollYPosition';
const { invertedDark } = creatorLightTheme;
const defaultColors = {
    text: invertedDark.text.base,
    background: invertedDark.background.base,
};
const StyledThemeWrapper = styled.div `
  ${flyoutTransitionMixin('background-color', 'color')};
`;
export const NavThemeProvider = ({ children, colors, }) => {
    const { activeSubmenu } = useActiveSubmenuContext();
    const activeItem = useSubmenuItem(activeSubmenu);
    const isFlyout = activeItem && isFlyoutSubMenu(activeItem);
    const scrollPos = useScrollYPosition();
    const isScrolling = scrollPos !== 0;
    const forceInvertedDark = isFlyout || isScrolling;
    return (React.createElement(ThemeProvider, { theme: forceInvertedDark
            ? {
                background: invertedDark.background.base,
                text: invertedDark.text.base,
                isFlyout: isFlyout,
                isScrolling,
                forceInvertedDark,
            }
            : Object.assign(Object.assign(Object.assign({}, defaultColors), colors), { isFlyout: isFlyout, isScrolling,
                forceInvertedDark }) },
        React.createElement(StyledThemeWrapper, null, children)));
};
//# sourceMappingURL=index.js.map